module.exports = __webpack_public_path__ + "static/media/heading_about_contact_info.ca2619a8.jpg";